import React from 'react';
import {Alert} from '@spothero/ui';
import {PROPTYPE_RESERVATION_COMMUTER_DETAILS} from '@/proptypes/reservation-prop-types';

const CommuterRateInfo = ({commuterRateDetails}) => {
    if (commuterRateDetails?.hasRate !== true) {
        return null;
    }

    return (
        <Alert
            marginTop={4}
            status="warning"
            title="Restrictions Apply"
            description={`Enter between ${commuterRateDetails.enterStart} - ${commuterRateDetails.enterEnd} to avoid a change in price.`}
        />
    );
};

CommuterRateInfo.propTypes = {
    commuterRateDetails: PROPTYPE_RESERVATION_COMMUTER_DETAILS.isRequired,
};

export default CommuterRateInfo;
